import React from 'react';
import PropTypes from 'prop-types';
import Container2 from './Container';
import BodyPortal from './BodyPortal';
import Gridlist from "../../gridlist";
import Imagelist from "../../../../AlbumContainer/AlbumBody/imagelist";
import Dedicatelist from "../../../../UserContainer/TabPanel/UserGallery/dedicategridlist";
import Uploadgridlist from "../../../../UserContainer/TabPanel/UserGallery/uploadgridlist";
import ReactPlayer from 'react-player';
import './Lightbox.css'

export default class Lightbox extends React.Component {
  constructor(props) {
    super(props);
   
    this.toggleLightbox = this.toggleLightbox.bind(this);
    this.state = {
      showLightbox: false,
      selectedImage: 0
    };
  }

  componentDidMount() {
    
  }

  toggleLightbox(idx) {
    const scrollTop = document.documentElement.scrollHeight;
    this.setState({
      showLightbox: !this.state.showLightbox,
      selectedImage: idx
    });
  }

  render() {
    let props = this.props;
    let images = props.images.map((image, idx) => {
      return props.renderImageFunc.call(
        this,
        idx,
        image,
        this.toggleLightbox,
        props.thumbnailWidth,
        props.thumbnailHeight
      );
    });
    let container;
    if (this.state.showLightbox)
      container = (
        <BodyPortal>
          <Container2
            {...this.props}
            toggleLightbox     = {this.toggleLightbox}
            selectedImage      = {this.state.selectedImage} 

            imageList          = {props.images}
            post_my_reaction   = {props.post_my_reaction}
            post_total_reaction= {props.post_total_reaction}
            post_total_comment = {props.post_total_comment}
            post_total_share   = {props.post_total_share}
            feed_id            = {props.carousalFeed}
            position           = {this.props.position}
          />
        </BodyPortal>
      )

    return (
      <div className='lightbox-container'>
         {(props.position == 'album') ? 
            <Imagelist media_details={props.images} toggleLightbox = {this.toggleLightbox} />
            : 
            (props.position == 'dedicates') ? 
              <Dedicatelist media_details={props.images} toggleLightbox = {this.toggleLightbox}/>
              :
                (props.position == 'uploads') ? 
                  <Uploadgridlist media_details={props.images} toggleLightbox = {this.toggleLightbox}/>
                   : <Gridlist media_details={props.images} toggleLightbox = {this.toggleLightbox}/>
          }
         
        {container}
      </div>
    )
  }
}

Lightbox.defaultProps = {
  showImageModifiers: true,
  thumbnailWidth: '80px',
  thumbnailHeight: '80px',
  renderImageFunc: (idx, image, toggleLightbox, width, height) => {
     return (
      (image.media_type == 'IMAGE') ?
      <img
        key={idx}
        src={image.media_type == 'IMAGE' ? image.media_link : image.media_link_thumbnail  }
        className='lightbox-img-thumbnail' 
        style={(idx == 0) ? {width: '100%', height: "300px"} : {width: width, height: height}}
        alt={image.media_link}
        onClick={toggleLightbox.bind(null, idx)} />
        :

        <div className="video-wrap"  key={idx}>
          <div className="play-btn"></div>
          <img
            key={idx}
            src={image.media_type == 'IMAGE' ? image.media_link : image.media_link_thumbnail  }
            className='lightbox-img-thumbnail' 
            style={(idx == 0) ? {width: '100%', height: "300px"} : {width: width, height: height}}
            alt={image.media_link}
            onClick={toggleLightbox.bind(null, idx)} />
        </div>
      
      
    )
  }
}

Lightbox.propTypes = {
 /*  images: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    thumbnail: PropTypes.string
  })).isRequired, */
  showImageModifiers: PropTypes.bool,
  thumbnailWidth: PropTypes.string,
  thumbnailHeight: PropTypes.string,
  renderImageFunc: PropTypes.func,
  renderDescriptionFunc: PropTypes.func
}
/*
images: PropTypes.arrayOf(PropTypes.shape({
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  thumbnail: PropTypes.string
})).isRequired,
*/